@if (productId) {
    <app-widget-process-step-group-list [autoFocusSearch]="false" [currentSearchInput]="startFilter" [noAddNew]="true"></app-widget-process-step-group-list>
}
